import { useMoralis } from "react-moralis";
import { useState, useContext } from "react";
import config from "../config/config.js";
import { useAuthContext } from "../AuthContext";
import { PaymentValidation } from "../component/Context/noteContext";
import { useNavigate } from "react-router-dom";
import { GamePopupContext } from "../component/Context/GamePopupContext";
import {
  FindGame,
  CreateGame,
  JoinGame,
  verifyRoom,
} from "../GameServices/GameServices";
import { CodeContext } from "../component/Context/CodeContext.js";

function useOneVOneContract() {
  const [paymentStarted, setPaymentStarted] = useState(false);
  const [scoreToBeat, setScoreToBeat] = useState(-1);
  const [opponentAddress, setOpponentAddress] = useState(0x00000000000000000);
  const { Moralis } = useMoralis();
  const { loggedInUser, isAuthenticated } = useAuthContext();
  const {
    paymentValidation,
    setPaymentValidation,
    transaction,
    setTransaction,
  } = useContext(PaymentValidation);
  const address = config.oneVoneContract;
  const abi = require("../config/oneVoneABI.json");
  const navigator = useNavigate();
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const { dispatch, state } = useContext(CodeContext);
  const { setErrorCode } = useAuthContext();

  const PlayWithFriend = async (name, stage) => {
    let options = {
      contractAddress: address,
      functionName: "createOrJoinGame",
      abi: abi,

      params: {
        gameName: name,
        gameStage: stage,
        ref: /* referral_address, */ "0x8fc73d9d27a730d4826e41babf76ee2d25f4736a",
      },
    };
    options.params.gameId = localStorage.getItem("gameId");
    try {
      setPaymentStarted(true);
      let game_payment = await Moralis.executeFunction(options);
      console.log("hash code here");
      if (game_payment.hash) {
        setTransaction(true);
        localStorage.setItem("transaction", true);
        setPaymentStarted(false);
      }
    } catch (err) {
      dispatchPopUp({
        name: "PAYMENT",
        type: "open",
        message: err.message,
      });
      setTimeout(() => {
        navigator(`/playgame/${name}`);
      }, 3000);
    }
  };
  const CreateService = async (
    gameName,
    value,
    type,
    options,
    isCustomBet,
    gameType
  ) => {
    console.log(gameName, value, type, options, isCustomBet, gameType);

    try {
      //     let createGame = await Moralis.executeFunction(options);
      //     const createGameResponse = await createGame.wait();

      //TODO: Call create or join game on contract with params for payment.
      const game_id = await CreateGame({
        // "gameType": "1v1",
        gameName: gameName,
        player_id:
          localStorage.getItem("user_id") ||
          "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
        betAmount: /* value */ 1,
        stage: type,
        isCustomBet: isCustomBet ? isCustomBet : false,
        type: gameType,
      });
      // console.log("actual game id", game_id);
      options.params.gameId = game_id.data.game.gameId;
      if (gameType === "PlayWithFriend") {
        dispatch({ type: "CODE", data: game_id?.data?.code?.code });
        localStorage.setItem("code", game_id?.data?.code?.code);
        localStorage.setItem("gameId", game_id.data.game.gameId);
      } else {
        console.log("actual game id");
        /* createGameResponse.events[1].args[1].toNumber() */
        //     if (createGame.hash && createGame.hash !== undefined) {
        setPaymentStarted(true);

        let game_payment = await Moralis.executeFunction(options);
        // console.log("hash code here", game_payment);
        if (game_payment.hash) {
          setTransaction(true);
          localStorage.setItem("transaction", true);
          setPaymentStarted(false);
          localStorage.setItem("gameId", game_id.data.game.gameId);
        }
      }
      // await JoinGame(localStorage.getItem("user_id") || "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A", game_id.data.game.gameId)
      //     } else {
      // setPaymentStarted(false);
    } catch (err) {
      //       //TODO:error handling
      //       console.log(createGameResponse);
      //     }
      //   } catch (err) {
      //     // console.log("asdasdasd", err);
      //     dispatchPopUp({ name: "PAYMENT", type: 'open', message: err.message })
      //     setTimeout(() => {
      //       navigator("/");
      //     }, 3000);
      //   }
      // } else {
      //   options.functionName = "joinGame";
      //   options.params = { _gameId: gameId };
      //   options.msgValue = value;
      //   console.log(options);
      //   setPaymentStarted(true);
      //   try {
      //     let joinGame = await Moralis.executeFunction(options);
      //     const joinGameResponse = await joinGame.wait();
      //     console.log("Join game: ", joinGameResponse.logs);
      //     if (joinGame.hash && joinGame.hash !== undefined) {
      //       setPaymentStarted(false);
      //       localStorage.setItem("transaction", true);
      //       setTransaction(true);
      //       localStorage.setItem("gameId", gameId.toNumber());
      //       fetchGameData(gameId.toNumber());
      //       enterGame(gameId.toNumber());
      //     } else {
      //       setPaymentStarted(false);
      //       console.log(joinGameResponse);

      //       //TODO: Read errors and display them properly.
      //     }
      //   }
      //TODO: On error screen show the me
      // console.log("Asdasdasdasdasda", err);
      console.log("error here", err.message);
      dispatchPopUp({
        name: "PAYMENT",
        type: "open",
        message: err.message,
      });
      setTimeout(() => {
        navigator(`/playgame/${gameName}`);
      }, 3000);
    }
  };

  try {
    const GameId = async (
      type,
      value,
      gameName,
      practice,
      isCustomBet,
      gameType,
      directJoin
    ) => {
      console.log("practice", gameType, directJoin);
      if (practice === true) {
        setTransaction(true);
      } else if (!isAuthenticated) {
        // TODO: Prompt user login
        navigator(`/playgame/${gameName}`);
        return;
      } else {
        if (typeof window.ethereum !== "undefined") {
          await Moralis.enableWeb3();
        } else {
          await Moralis.enableWeb3({ provider: "walletConnect" });
        }
        let referral_address =
          localStorage.getItem("referAddress") !== null
            ? localStorage.getItem("referAddress")
            : "";

        let options = {
          contractAddress: address,
          functionName: "createOrJoinGame",
          abi: abi,

          params: {
            gameName: gameName,
            gameStage: type,
            ref: /* referral_address, */ "0x8fc73d9d27a730d4826e41babf76ee2d25f4736a",
          },
        };

        if (isCustomBet && directJoin === false) {
          CreateService(gameName, value, type, options, isCustomBet, gameType);
        } else if (gameType === "PlayWithFriend" && directJoin === true) {
          PlayWithFriend(gameName, type);
        } else if (isCustomBet && directJoin === true) {
          let { data } = await verifyRoom(state?.code);
          console.log("data here", data.challenge.gameId);
          dispatch({ type: "GAMEID", data: data?.challenge?.gameId });
          options.params.gameName = data.challenge.gameName;
          options.params.gameStage = data.challenge.stage;
          options.params.gameId = data.challenge.gameId;
          setPaymentStarted(true);
          localStorage.setItem("transaction", true);

          // localStorage.setItem("gameId", game_id.game.gameId);
          //TODO: Call create or join game on contract with params for payment. 4 params
          // console.log("options", options);
          let game_payment = await Moralis.executeFunction(options);
          // console.log('hash code here', game_payment);
          if (game_payment.hash) {
            setTransaction(true);
            setPaymentStarted(false);
          }

          if (localStorage.getItem("gameId") !== -1) {
            await JoinGame(
              localStorage.getItem("user_id") ||
                "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
              data.challenge.gameId
            );
          }
        } else if (gameType == "OneVSOne" && directJoin === true) {
          let game_id = localStorage.getItem("gameId");
          options.params.gameId = game_id;
          setPaymentStarted(true);
          localStorage.setItem("transaction", true);

          // localStorage.setItem("gameId", game_id.game.gameId);
          //TODO: Call create or join game on contract with params for payment. 4 params
          // console.log("options", options);
          let game_payment = await Moralis.executeFunction(options);
          // console.log('hash code here', game_payment);
          if (game_payment.hash) {
            setTransaction(true);
            setPaymentStarted(false);
          }
          if (localStorage.getItem("gameId") !== -1) {
            await JoinGame(
              localStorage.getItem("user_id") ||
                "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
              game_id
            );
          }
        } else {
          let { data } = await FindGame(
            {
              gameName: gameName,
              betAmount: /* value */ 1,
              player_id:
                localStorage.getItem("user_id") ||
                "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
              stage: type,
            },
            false
          );
          console.log("game id", data.gameId);
          if (data.gameId === -1 || data.gameId === -2) {
            CreateService(gameName, value, type, options, false, gameType);
          } else {
            localStorage.setItem("gameId", data.gameId);
            options.params.gameId = data.gameId;
            setPaymentStarted(true);
            localStorage.setItem("transaction", true);
            try {
              let game_payment = await Moralis.executeFunction(options);
              if (game_payment.hash) {
                setTransaction(true);
                setPaymentStarted(false);
              }
            } catch (err) {
              dispatchPopUp({
                name: "PAYMENT",
                type: "open",
                message: err.message,
              });
              setTimeout(() => {
                navigator(`/playgame/${gameName}`);
              }, 3000);
              console.log("error here", err);
            }
            await JoinGame(
              localStorage.getItem("user_id") ||
                "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
              localStorage.getItem("gameId")
            );
          }
        }
      }
    };
    return {
      GameId,
      paymentStarted,
      scoreToBeat,
      opponentAddress,
      PlayWithFriend,
    };
  } catch (err) {
    console.log("Error here", err);
    dispatchPopUp({
      name: "PAYMENT",
      type: "open",
      message: err.message,
    });
    setTimeout(() => {
      navigator(`/home`);
    }, 3000);
  }

  function enterGame(gameId) {
    window.fetch(`${config.apiURL}/oneVone/game/enter`, {
      method: "POST",
      body: JSON.stringify({
        player: loggedInUser,
        gameId: gameId,
      }),
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    });
  }

  function fetchGameData(gameId) {
    fetch(`${config.apiURL}/onevone/game/${gameId}`)
      .then((response) => response.json())
      .then((response) => {
        setOpponentAddress(response.data.player1);
        setScoreToBeat(response.data.score1);
      });
  }
}

export default useOneVOneContract;
